import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      <video src='/videos/video-1.mp4' autoPlay loop muted playsInline />
      <h1>Welcome</h1>
      <p>My name is Emre and I am a software developer</p>
      <div className='hero-btns'>
        
          <Button
            className='btns'
            buttonStyle='btn--outline'
            buttonSize='btn--large'
            path='/about'
          >
            About Me
          </Button>
      
          <Button
            className='btns'
            buttonStyle='btn--primary'
            buttonSize='btn--large'
            path='/contact'
          >
            Contact Me 
          </Button>
      
      </div>
    </div>
  );
}

export default HeroSection;
